// actions.js

export const ADD_TO_CART = 'ADD_TO_CART';
export const DELETE_FROM_CART = 'DELETE_FROM_CART';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_FOODS_BY_CATEGORY = 'SET_FOODS_BY_CATEGORY';
export const PLACE_ORDER_REQUEST = 'PLACE_ORDER_REQUEST';
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';
export const PLACE_ORDER_FAILURE = 'PLACE_ORDER_FAILURE';
export const SET_SCANNED_TABLE_ID = 'SET_SCANNED_TABLE_ID';
export const FETCH_FOODS_REQUEST = 'FETCH_FOODS_REQUEST';
export const FETCH_FOODS_SUCCESS = 'FETCH_FOODS_SUCCESS';
export const FETCH_FOODS_FAILURE = 'FETCH_FOODS_FAILURE';
export const SET_MERCHANTS = 'SET_MERCHANTS';
export const CLEAR_CART = 'CLEAR_CART';

const API_URL = process.env.REACT_APP_API_URL;

const commissionRates = {
  'Main course': 0.20,
  'Side Dish': 0.30,
  'Snacks': 0.10,
  'Desserts': 0.10,
  'Appetizer': 0.10,
  'Alcohol': 0.10,
  'Drinks': 0.10,
  'Soup': 0.10,
};

// ---------- Helper ----------
const calculateExtras = (arr = []) =>
  arr.reduce((sum, item) => sum + (item.addOnPrice || 0), 0);

// ---------- Cart Actions ----------
export const addToCart = (item) => {
  let merchantId = item.merchantId;
  if (!merchantId && item.merchant) {
    merchantId = item.merchant._id;
  }

  if (!merchantId) {
    console.error('addToCart missing merchantId:', item);
  }

  return {
    type: ADD_TO_CART,
    payload: {
      ...item,
      merchantId,
      quantity: 1,
      addons: item.addons || [],
      specialRequest: item.specialRequest || [],
      extraRequest: item.extraRequest || [],
    },
  };
};

export const deleteFromCart = (index) => ({
  type: DELETE_FROM_CART,
  payload: index,
});

export const clearCart = () => ({
  type: CLEAR_CART,
});

// ---------- Category ----------
export const setCategories = (categories) => ({
  type: SET_CATEGORIES,
  payload: categories,
});

export const setFoodsByCategory = (foodsByCategory) => ({
  type: SET_FOODS_BY_CATEGORY,
  payload: foodsByCategory,
});

// ---------- ✅ FIXED PLACE ORDER ----------
// export const placeOrder = (cartItems, paymentMethod) => {
//   return async (dispatch) => {
//     dispatch({ type: PLACE_ORDER_REQUEST });

//     try {
//       const tableId = localStorage.getItem('scannedTableId');
//       if (!tableId) throw new Error('Table ID not found');

//       const ordersByMerchant = {};

//       cartItems.forEach((item) => {
//         const merchantId = item.merchantId;
//         if (!merchantId) return;

//         if (!ordersByMerchant[merchantId]) {
//           ordersByMerchant[merchantId] = {
//             merchantId,
//             foods: [],
//             amount: 0,
//             commission: 0,
//           };
//         }

//         ordersByMerchant[merchantId].foods.push({
//           foodId: item._id,
//           quantity: item.quantity,
//           note: item.note || '',
//           addons: item.addons || [],
//           specialRequest: item.specialRequest || [],
//           extraRequest: item.extraRequest || [],
//         });

//         const extras =
//           calculateExtras(item.addons) +
//           calculateExtras(item.specialRequest) +
//           calculateExtras(item.extraRequest);

//         const itemTotal = (item.price + extras) * item.quantity;
//         ordersByMerchant[merchantId].amount += itemTotal;

//         const rate = commissionRates[item.category] || 0.10;
//         ordersByMerchant[merchantId].commission += rate * item.quantity;
//       });

//       const ordersPayload = Object.values(ordersByMerchant).map((order) => ({
//         merchantId: order.merchantId,
//         foods: order.foods,
//         amount: order.amount,
//         commission: order.commission,
//         paidAmount: 0,
//         payment: paymentMethod,
//       }));

//       if (ordersPayload.length === 0) {
//         throw new Error('No valid orders');
//       }

//       const response = await fetch(`${API_URL}/orders`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ tableId, orders: ordersPayload }),
//       });

//       const data = await response.json();

//       if (!response.ok) {
//         console.error('Order error:', data);
//         throw new Error(data.error || 'Order failed');
//       }

//       dispatch({
//         type: PLACE_ORDER_SUCCESS,
//         payload: data.createdOrders,
//       });

//       dispatch(clearCart());

//       // ✅ VERY IMPORTANT (FIX)
//       return {
//         success: true,
//         data: data.createdOrders,
//         raw: data,
//       };

//     } catch (error) {
//       console.error('Order placement error:', error);

//       dispatch({
//         type: PLACE_ORDER_FAILURE,
//         payload: error.message,
//       });

//       // ✅ VERY IMPORTANT (FIX)
//       throw error;
//     }
//   };
// };

export const placeOrder = (cartItems, paymentMethod) => {
  return async (dispatch) => {
    dispatch({ type: PLACE_ORDER_REQUEST });

    try {
      const tableId = localStorage.getItem('scannedTableId');
      if (!tableId) throw new Error('Table ID not found');

      const ordersByMerchant = {};

   cartItems.forEach((item) => {
  const merchantId = item.merchantId;
  if (!merchantId) return;

  if (!ordersByMerchant[merchantId]) {
    ordersByMerchant[merchantId] = {
      merchantId,
      foods: [],
      amount: 0,
      commission: 0,
    };
  }

  let categoryName = 'Others';

  if (item.category) {
    categoryName = item.category;
  } else if (Array.isArray(item.categories) && item.categories.length > 0) {
    categoryName = item.categories[0];
  }

  const extras =
    calculateExtras(item.addons) +
    calculateExtras(item.specialRequest) +
    calculateExtras(item.extraRequest);

  const itemQty = Number(item.quantity || 1);
  const itemTotal = (Number(item.price || 0) + extras) * itemQty;

  // ✅ fixed commission per quantity
  const commissionRate = commissionRates[categoryName] || 0.10;
  const itemCommission = commissionRate * itemQty;

  ordersByMerchant[merchantId].foods.push({
    foodId: item._id,
    title: item.title || '',
    price: item.price || 0,
    quantity: itemQty,
    category: categoryName,
    commissionRate,
    commission: Number(itemCommission.toFixed(2)),
    note: item.note || '',
    addons: item.addons || [],
    specialRequest: item.specialRequest || [],
    extraRequest: item.extraRequest || [],
  });

  ordersByMerchant[merchantId].amount += itemTotal;
  ordersByMerchant[merchantId].commission += itemCommission;
});

      const ordersPayload = Object.values(ordersByMerchant).map((order) => ({
        merchantId: order.merchantId,
        foods: order.foods,
        amount: Number(order.amount.toFixed(2)),
        commission: Number(order.commission.toFixed(2)),
        commissionDetails: order.commissionDetails,
        paidAmount: 0,
        payment: paymentMethod,
      }));

      if (ordersPayload.length === 0) {
        throw new Error('No valid orders');
      }

      const response = await fetch(`${API_URL}/orders`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tableId, orders: ordersPayload }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('Order error:', data);
        throw new Error(data.error || 'Order failed');
      }

      dispatch({
        type: PLACE_ORDER_SUCCESS,
        payload: data.createdOrders,
      });

      dispatch(clearCart());

      return {
        success: true,
        data: data.createdOrders,
        raw: data,
      };
    } catch (error) {
      console.error('Order placement error:', error);

      dispatch({
        type: PLACE_ORDER_FAILURE,
        payload: error.message,
      });

      throw error;
    }
  };
};

// ---------- Food Fetch ----------
export const fetchFoodsRequest = () => ({
  type: FETCH_FOODS_REQUEST,
});

export const fetchFoodsSuccess = (foods) => ({
  type: FETCH_FOODS_SUCCESS,
  payload: foods,
});

export const fetchFoodsFailure = (error) => ({
  type: FETCH_FOODS_FAILURE,
  payload: error,
});

export const fetchFoods = () => {
  return async (dispatch) => {
    dispatch(fetchFoodsRequest());

    try {
      const response = await fetch(`${API_URL}/foods/mfoods`);
      const data = await response.json();

      const flattenedFoods = [];

      data.forEach((merchantData) => {
        const merchantId = merchantData.merchant._id;

        merchantData.foods.forEach((food) => {
          flattenedFoods.push({
            ...food,
            merchantId,
            merchant: merchantData.merchant,
          });
        });
      });

      dispatch(fetchFoodsSuccess(flattenedFoods));

    } catch (error) {
      dispatch(fetchFoodsFailure(error.message));
    }
  };
};

// ---------- Table ----------
export const setScannedTableId = (tableId) => ({
  type: SET_SCANNED_TABLE_ID,
  payload: tableId,
});

export const setMerchants = (merchants) => ({
  type: SET_MERCHANTS,
  payload: merchants,
});